export function managementLinkSerialError(value: string): string | null {
  if (value === '') {
    return 'シリアル番号は必須です。';
  }
  if (!/^[A-Za-z0-9]+$/.test(value)) {
    return '英数字で入力してください。';
  }
  return null;
}
